import React from "react";
import Company from "components/Tvendo/Distribution/DataMaster/Company/List";

export default function () {
  return <Company />;
}
